import {useEffect} from "react";
import {managePassengerClassesState} from "@CheckOrder/reducers/checkOrderSlice";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import findDefaultPassengerClass from "@CheckOrder/features/classPicker/functions/findDefaultPassengerClass";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";
import AvailablePassengerClassesGroupType
    from "@CheckOrder/features/classPicker/types/AvailablePassengerClassesGroup.type";

export default function useSelectedPassengerClass(
    passengerId: number,
    extendedAvailablePassengerClassesGroups: AvailablePassengerClassesGroupType[],
    isReturn?: boolean
) {
    const {
        singleSelectedPassengerClasses,
        returnSelectedPassengerClasses,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const dispatch = useAppDispatch()

    const selectedPassengerClasses = isReturn ? returnSelectedPassengerClasses : singleSelectedPassengerClasses

    const setSelectedPassengerClass = (passengerClass: AvailablePassengerClassType, passengerGroupIndex?: number) => {
        dispatch(managePassengerClassesState({
            passengerToPassengerClassData: {[passengerId]: passengerClass},
            passengerGroupIndex,
            isReturn,
        }))
    }

    useEffect(() => {
        if (!selectedPassengerClasses.passengerToPassengerClassMap[passengerId]) {
            setSelectedPassengerClass(findDefaultPassengerClass(extendedAvailablePassengerClassesGroups))
        }
    }, []);

    const selectedPassengerClass: AvailablePassengerClassType | undefined = selectedPassengerClasses.passengerToPassengerClassMap[passengerId] ?? undefined

    return {
        selectedPassengerClass,
        setSelectedPassengerClass,
    }
}